
import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';
import shortid from 'shortid';

import styles from './styles.js';

const HorizontalTabs = ({ activeVerticalId, clickAction, tabItems }) => {
    return (
        <div>
            <div
                role="tablist"
                className={css(styles.tabs)}
            >
                <div className={css(styles.containerRelative)}>
                    <div className={css(styles.containerOuter)}>
                        <div className={css(styles.containerInner)}>
                            <div className={css(styles.preMenu)} />
                            {tabItems.map((tabItem) => (
                                <a
                                    key={shortid.generate()}
                                    className={
                                        Number(activeVerticalId) === Number(tabItem.id) ?
                                            css(styles.text, styles.textActive) :
                                            css(styles.text)
                                    }
                                    role="tab"
                                    title={
                                        typeof tabItem.title !== 'undefined' ?
                                            tabItem.title : ''
                                    }
                                    data-vertical-id={tabItem.id}
                                    data-vertical-slug={tabItem.slug}
                                    onClick={clickAction}
                                >
                                    {tabItem.title}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

HorizontalTabs.propTypes = {
    activeVerticalId: PropTypes.number,
    clickAction: PropTypes.func,
    tabItems: PropTypes.array.isRequired
};

export default HorizontalTabs;



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/HorizontalTabs/HorizontalTabs.jsx